import { useQuery } from '@tanstack/react-query'

import { fleetApi } from '@/lib/api/fleet-api'

export const fleetKeys = {
    all: ['fleet'] as const,
    list: () => [...fleetKeys.all, 'list'] as const,
}

export function useFleet(enabled = true) {
    return useQuery({
        queryKey: fleetKeys.list(),
        queryFn: async () => {
            const res = await fleetApi.list()
            return res.data ?? []
        },
        enabled,
        refetchInterval: 20_000,
        refetchIntervalInBackground: false,
    })
}
